import * as THREE from "three";
import { Context } from "../core/context";
import { DBEntity, DbLine, DbMesh, FMathUtils } from "@/CadEngine";
import {
  ModifyOperateState,
  DrawOperationMovePointBeforeParams,
  DrawOperationMovePointParams,
  IModifyOperation,
} from "./IModifyOperation";
import { ReversalModifyState, ReversalReturnData } from "@/core/Parameters";

class ReversalModify implements IModifyOperation {
  private onMouseMoveBind: ((e: PointerEvent) => void) | undefined;
  private onMouseUpBind: ((e: PointerEvent) => void) | undefined;
  private m_context: Context;
  private m_selects: DBEntity[] = [];
  private m_state: ReversalModifyState = ReversalModifyState.TOP;
  private m_returnData: ReversalReturnData = {
    reversalDatas: [],
    sourceDatas: [],
  };

  constructor(context: Context, type: ReversalModifyState) {
    this.m_context = context;
    this.m_state = type;
    this.m_selects = context.SelectionManager.GetSelected() as DBEntity[];
    for (let i = 0; i < this.m_selects.length; i++) {
      let select = this.m_selects[i];
      if (select instanceof DbLine) {
        this.m_returnData.sourceDatas.push(DbLine.clone(select));
      } else if (select instanceof DbMesh) {
        this.m_returnData.sourceDatas.push(DbMesh.clone(select));
      }
    }

    this.FilterSelectDatas(this.m_selects);
    setTimeout(() => {
      this.m_context.ModifyManager.ModifyFinish(ModifyOperateState.complete);
    }, 200);
  }

  OnMovePointBefore(params: DrawOperationMovePointBeforeParams): void {}
  OnMovePoint(point: DrawOperationMovePointParams): void {}
  OnDownPoint(point: DrawOperationMovePointParams): void {}
  onKeyDown(e: KeyboardEvent): void {}
  onKeyUp(e: KeyboardEvent): void {}
  OnZoom(camera: THREE.Camera): void {}

  Finish(operate: ModifyOperateState) {
    return this.m_returnData;
  }
  OnWheel(e: WheelEvent): void {}

  onMouseMove(e: PointerEvent): void {}
  onMouseDown(e: PointerEvent): void {}
  onMouseUp(e: PointerEvent): void {}

  private FilterSelectDatas(data: DBEntity[]) {
    let Ids: string[] = [];
    let filterDatas: (DbLine | DbMesh)[] = [];
    for (let i = 0; i < data.length; i++) {
      if (data[i].root_reference_id) {
        if (!Ids.includes(data[i].root_reference_id!)) {
          Ids.push(data[i].root_reference_id!);
          filterDatas.push(data[i] as DbLine | DbMesh);
        }
      } else {
        let assembly_code = data[i].id + data[i].block_path + data[i].extend_id;
        if (!Ids.includes(assembly_code)) {
          Ids.push(assembly_code);
          filterDatas.push(data[i] as DbLine | DbMesh);
        }
      }
    }

    filterDatas.forEach((item) => {
      this.ByDataUpdateModel(item);
    });
  }

  private ByDataUpdateModel(data: DbLine | DbMesh) {
    let ModelManager = this.m_context.ModelManager;
    let rootId = data.root_reference_id;
    let key = data.layerId + "_" + data.color;
    let lineModel = ModelManager.Lines[key];
    let meshModel = ModelManager.Meshs[key];
    if (rootId) {
      let keys = ModelManager.Group[rootId].key;
      let lines = ModelManager.Group[rootId].lines;
      let meshs = ModelManager.Group[rootId].mesh;
      let blockIdAndRootId = data.blockId + ":" + data.root_reference_id;
      let rootIdMatrix =
        this.m_context.ToolsManager.passBlockIdAndRootIdGetMatrix(
          blockIdAndRootId
        ) as unknown as THREE.Matrix4;
      // let pos = new THREE.Vector3(
      //   rootIdMatrix.elements[12],
      //   rootIdMatrix.elements[13],
      //   rootIdMatrix.elements[14]
      // );
      let composeM = this.MirrorMatrix(rootIdMatrix);

      for (let i = 0; i < lines.length; i++) {
        for (let j = 0; j < lines[i].points.length; j += 3) {
          let vector = new THREE.Vector3(
            lines[i].points[j],
            lines[i].points[j + 1],
            lines[i].points[j + 2]
          );
          vector.applyMatrix4(composeM);
          lines[i].points[j] = vector.x;
          lines[i].points[j + 1] = vector.y;
          lines[i].points[j + 2] = vector.z;
        }
      }
      for (let i = 0; i < meshs.length; i++) {
        for (let j = 0; j < meshs[i].vertexs.length; j += 3) {
          let vector = new THREE.Vector3(
            meshs[i].vertexs[j],
            meshs[i].vertexs[j + 1],
            meshs[i].vertexs[j + 2]
          );
          vector.applyMatrix4(composeM);
          meshs[i].vertexs[j] = vector.x;
          meshs[i].vertexs[j + 1] = vector.y;
          meshs[i].vertexs[j + 2] = vector.z;
        }
      }

      this.m_context.ModelManager.updateReferencesGeometry(lines);
      this.m_context.ModelManager.updateReferencesGeometry(meshs);

      let { Lines, Meshs } = this.m_context.ModelManager;
      for (let i = 0; i < keys.length; i++) {
        let key = keys[i];
        if (Lines[key]) {
          this.m_context.ToolsManager.LinesToModel(
            Lines[key].lines,
            Lines[key].model
          );
        }
        if (Meshs[key]) {
          this.m_context.ToolsManager.MeshToModel(
            Meshs[key].meshs,
            Meshs[key].model
          );
        }
      }

      this.m_context.ModelManager.ByDatasUpdateModel(lines);
      this.m_context.ModelManager.ByDatasUpdateModel(meshs);

      this.m_returnData.reversalDatas.push({
        extendId: data.extend_id!,
        reversalMatrix: composeM,
      });
    } else {
      let str = data.block_path + data.id + data.extend_id;
      if (data instanceof DbLine) {
        for (let i = 0; i < lineModel.lines.length; i++) {
          let line = lineModel.lines[i];
          if (str == line.block_path + line.id + line.extend_id) {
            let pos = new THREE.Vector3(
              line.sphere?.center.x,
              line.sphere?.center.y,
              0
            );

            let composeM = this.MirrorMatrix(
              new THREE.Matrix4().setPosition(pos)
            );
            for (let j = 0; j < line.points.length; j += 3) {
              let vector = new THREE.Vector3(
                line.points[j],
                line.points[j + 1],
                line.points[j + 2]
              );
              vector.applyMatrix4(composeM);
              line.points[j] = vector.x;
              line.points[j + 1] = vector.y;
              line.points[j + 2] = vector.z;
            }
            this.m_returnData.reversalDatas.push({
              extendId: data.extend_id!,
              reversalMatrix: composeM,
            });
            this.m_context.ToolsManager.LinesToModel(
              lineModel.lines,
              lineModel.model
            );
            break;
          }
        }
      } else if (data instanceof DbMesh) {
        for (let i = 0; i < meshModel.meshs.length; i++) {
          let meshs = meshModel.meshs[i];
          if (str == meshs.block_path + meshs.id + meshs.extend_id) {
            let pos = new THREE.Vector3(
              meshs.sphere?.center.x,
              meshs.sphere?.center.y,
              0
            );
            let composeM = this.MirrorMatrix(
              new THREE.Matrix4().setPosition(pos)
            );
            for (let j = 0; j < meshs.vertexs.length; j += 3) {
              let vector = new THREE.Vector3(
                meshs.vertexs[j],
                meshs.vertexs[j + 1],
                meshs.vertexs[j + 2]
              );
              vector.applyMatrix4(composeM);
              meshs.vertexs[j] = vector.x;
              meshs.vertexs[j + 1] = vector.y;
              meshs.vertexs[j + 2] = vector.z;
            }
            this.m_returnData.reversalDatas.push({
              extendId: data.extend_id!,
              reversalMatrix: composeM,
            });
            this.m_context.ToolsManager.MeshToModel(
              meshModel.meshs,
              meshModel.model
            );
            break;
          }
        }
      }
    }
  }

  private MirrorMatrix(matrix: THREE.Matrix4) {
    let p = new THREE.Vector3();
    let q = new THREE.Quaternion();
    let s = new THREE.Vector3();
    matrix.decompose(p, q, s);
    let angle = new THREE.Euler().setFromQuaternion(q).z;
    let Tmatrix = new THREE.Matrix4();
    Tmatrix.makeTranslation(p.x, p.y, p.z);
    let zAxis = new THREE.Vector3(0, 0, 1);
    let ABV = new THREE.Vector3(0, 1, 0);
    if (this.m_state == ReversalModifyState.TOP) {
      ABV = new THREE.Vector3(-1, 0, 0);
    }
    ABV.applyAxisAngle(zAxis, angle);
    angle += Math.PI;
    if (angle > Math.PI * 2) {
      angle -= Math.PI * 2;
    }
    q.setFromAxisAngle(zAxis, angle);
    matrix.compose(p, q, s);
    let unitDeltV = zAxis.cross(ABV).normalize();
    let m = new THREE.Matrix4();
    m.set(
      1 - 2 * unitDeltV.x * unitDeltV.x,
      -2 * unitDeltV.x * unitDeltV.y,
      -2 * unitDeltV.x * unitDeltV.z,
      0,
      -2 * unitDeltV.x * unitDeltV.y,
      1 - 2 * unitDeltV.y * unitDeltV.y,
      -2 * unitDeltV.y * unitDeltV.z,
      0,
      -2 * unitDeltV.x * unitDeltV.z,
      -2 * unitDeltV.y * unitDeltV.z,
      1 - 2 * unitDeltV.z * unitDeltV.z,
      0,
      0,
      0,
      0,
      1
    );
    m.transpose();
    let composeM = Tmatrix.clone()
      .multiply(m)
      .multiply(Tmatrix.clone().invert()); //反射矩阵
    return composeM;
  }
}

export { ReversalModify, ReversalModifyState };
